import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "common/configs/axiosConfigs";
import { toast } from "react-toastify";
import { formatDate, formatDateTime } from "common/constants/functions";

const ContactDetails = () => {
  const { id } = useParams();
  const companyId = JSON.parse(localStorage.getItem("user-auth")).company_id;
  const [contact, setContact] = useState({});
  const getContact = async () => {
    try {
      const { data } = await axios.post("", {
        action: "getSingleContact",
        contactId: id,
        companyId,
      });
      if (data?.success) {
        setContact(data?.data);
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getContact();
  }, []);
  return (
    <section>
      <h4 className="page-title">Contact Details</h4>
      <div className="card">
        <div className="text-center">
          <h5>
            {contact?.honorifics}. {contact?.first_name} {contact?.last_name}
          </h5>
          <p className="text-muted mb-0">{contact?.email}</p>
          <span
            className={`badge py-2 px-4 mt-3 ${
              contact?.status ? "text-success bg-success-50" : "text-danger bg-danger-50"
            } `}
          >
            {contact?.status ? "Active" : "Inactive"}
          </span>
          <span className="badge  mt-3 py-2 px-4 bg-warning ms-2 text-dark">
            Ref: {contact?.refer_by}
          </span>
        </div>
        <hr />
        <h6 className="mb-3">CONTACT INFORMATION</h6>
        <div className="row ">
          <div className="col-6 col-lg-4">
            <span className="text-muted">Phone No.</span>
            <p className="fw-medium">{contact?.phone}</p>
          </div>
          <div className="col-6 col-lg-4">
            <span className="text-muted">Alternative No.</span>
            <p className="fw-medium">{contact?.alternative_number || "-"}</p>
          </div>
          <div className="col-6 col-lg-4">
            <span className="text-muted">Date of Birth</span>
            <p className="fw-medium">{formatDate(contact?.dob)}</p>
          </div>
          <div className="col-6 col-lg-4">
            <span className="text-muted">Address</span>
            <p className="fw-medium">{contact?.address || "-"}</p>
          </div>
          <div className="col-6 col-lg-4">
            <span className="text-muted">City</span>
            <p className="fw-medium">{contact?.city || "-"}</p>
          </div>
          <div className="col-6 col-lg-4">
            <span className="text-muted">Locality</span>
            <p className="fw-medium">{contact?.locality || "-"}</p>
          </div>
          <div className="col-6 col-lg-4">
            <span className="text-muted">Pincode</span>
            <p className="fw-medium">{contact?.pincode || "-"}</p>
          </div>
        </div>
      </div>
      <div className="card mt-3">
        <h6 className="mb-3">COMPANY INFORMATION</h6>
        <div className="row">
          <div className="col-6 col-lg-4">
            <span className="text-muted">Company</span>
            <p className="fw-medium">{contact?.company || "-"}</p>
          </div>
          <div className="col-6 col-lg-4">
            <span className="text-muted">Bank Name</span>
            <p className="fw-medium">{contact?.bank_name || "-"}</p>
          </div>
          <div className="col-6 col-lg-4">
            <span className="text-muted">Bank Account no.</span>
            <p className="fw-medium">{contact?.bank_ac || "-"}</p>
          </div>
          <div className="col-6 col-lg-4">
            <span className="text-muted">Bank IFSC Code</span>
            <p className="fw-medium">{contact?.bank_ifsc || "-"}</p>
          </div>
        </div>
      </div>
      <div className="card mt-3">
        <h6 className="mb-3">OTHER INFORMATION</h6>
        <div className="row">
          <div className="col-6 col-lg-4">
            <span className="text-muted">Remark</span>
            <p className="fw-medium">{contact?.remarks || "-"}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactDetails;
